import axios from "../api/axiosInstance";

export const GetAllOrderItem = async () => {
    return await axios.get("/OrderItem/GetOrderItemList");
};

export const GetOrderItemById = async (id) => {
    return await axios.get("/OrderItem/GetOrderItemById", {
        params: { id }
    });
};

export const GetOrderItemsByOrderId = async (orderId) => {
    return await axios.get("/OrderItem/GetOrderItemsByOrderId", {
        params: { orderId }
    });
};

export const GetOrderItemsByProductId = async (productId) => {
    return await axios.get("/OrderItem/GetOrderItemsByProductId", {
        params: { productId }
    });
};

export const AddOrderItem = async (model) => {
    return await axios.post("/OrderItem/AddOrderItem", model);
};

export const UpdateOrderItem = async (model) => {
    return await axios.post("/OrderItem/UpdateOrderItem", model);
};

export const RemoveOrderItem = async (id) => {
    return await axios.post("/OrderItem/RemoveOrderItem", null, {
        params: { id }
    });
};